import styled, { css } from 'styled-components'
import { maxWidth, minWidth } from '@/assets/styles/mixins.css.js'
import vars from '@/assets/styles/vars'
import {StyledWidget} from '@/components/styles'

const ScrollBtn = styled.button`
  position: fixed;
  right: 86px;
  bottom: calc(23px + var(--el-cta-offset, 0px));
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 65px;
  height: 65px;
  color: var(--color-decor);
  background: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  opacity: 1;
  visibility: visible;
  transform: none;
  transition: opacity 0.3s ease-out, transform 0.3s ease-out, visibility 0s;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    padding: 18px;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    bottom: calc(48px + var(--el-cta-offset, 0px));
    right:24px;
    width: 57px;
    height: 57px;
  `}

  ${props =>
    !props.visible &&
    css`
      opacity: 0;
      visibility: hidden;
      transform: translateY(60px);
      pointer-events: none;
      transition: opacity 0.3s ease-out, transform 0.3s ease-out, visibility 0s 0.3s; 
      & + ${StyledWidget} {
        bottom: calc(23px + var(--el-cta-offset, 0px));
      }
    `}
`

export default ScrollBtn
